import {getReport} from "../../api/fileReport";

const state = () => ({

    fileReport:'',
})


const getters = {
    get_FileReport(state) {
        return state.fileReport;
    },
}

const mutations = {
    SET_FILEREPORT(state,data){
        state.fileReport = data;}
}

const actions = {
    async fetchFileReport({ commit },payload) {
        const response = await getReport(payload);
        commit('SET_FILEREPORT', response.data);
    },

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
